import React from 'react';
import { usePhotoURL } from './profilePhoto';

/** A user's photo laid over their initials. Draws nothing without a photo. */
export default function AvatarPhoto({ uid }) {
  const url = usePhotoURL(uid);
  if (!url) return null;
  return <img className="avatar-photo" src={url} alt="" loading="lazy" />;
}
